import { OtherPanel } from './WalletShared';
import { WALLET_FEATURES, filterProdRoutes, PROD_HIDDEN_WALLET_FEATURES, PROD_WALLET_FUEL_LABEL_KEY } from '@/constants';
import { FEATURE_TILE_GRID_CLASS, FeatureTileCell, GridFeatureTile } from './GridFeatureTile';

type Translate = (key: string) => string;

export function FeatureGrid({ t, onNavigate }: { t: Translate; onNavigate: (to: string) => void }) {
  const features = filterProdRoutes([...WALLET_FEATURES]).filter(
    (f) => !PROD_HIDDEN_WALLET_FEATURES.has(f.labelKey) && f.labelKey !== PROD_WALLET_FUEL_LABEL_KEY,
  );

  if (features.length === 0) return null;

  return (
    <OtherPanel className="p-4">
      <div className={FEATURE_TILE_GRID_CLASS}>
        {features.map(({ labelKey, to, icon }) => (
          <FeatureTileCell key={to}>
            <GridFeatureTile
              label={t(labelKey)}
              icon={icon}
              onClick={() => onNavigate(to)}
              className="h-full w-full"
            />
          </FeatureTileCell>
        ))}
      </div>
    </OtherPanel>
  );
}